import React, { useContext } from "react";
import { AppContext } from "../../../../appContext";
import { IAnalysisFolder } from "../fullAnalysis/IAnalysisFolder";
import "./FileCombinationPopup.css";

interface IFileCombinationPopupProps {
    sourceFile: IAnalysisFolder;
    targetFile: IAnalysisFolder;
    onYes: () => void;
    onNo: () => void;
    onClose: () => void;
}

export const FileCombinationPopup = ({sourceFile, targetFile, onYes, onNo, onClose}: IFileCombinationPopupProps) => {
    const { translate } = useContext(AppContext);

    return (
        <div className="FileCombinationPopup_overlay" onClick={onClose}>
            <div className="FileCombinationPopup" onClick={(e) => e.stopPropagation()}>
                <div className="FileCombinationPopup_header">
                    <div className="FileCombinationPopup_title">Combine Files</div>
                    <button className="FileCombinationPopup_close" onClick={onClose}>×</button>
                </div>
                
                <div className="FileCombinationPopup_content">
                    <div className="FileCombinationPopup_question">
                        Do you want to combine '{sourceFile.name}' and '{targetFile.name}'?
                    </div>
                    
                    <div className="FileCombinationPopup_description">
                        <strong>Yes</strong> - The content of '{sourceFile.name}' will be appended to '{targetFile.name}'
                        <br />
                        <strong>No</strong> - '{sourceFile.name}' will be placed in a nearby location
                    </div>
                </div>
                
                <div className="FileCombinationPopup_buttons">
                    <button className="FileCombinationPopup_button FileCombinationPopup_button--no" onClick={onNo}>
                        No
                    </button>
                    <button className="FileCombinationPopup_button FileCombinationPopup_button--yes" onClick={onYes}>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
};